import axios from "axios";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { Modal } from "react-bootstrap";
import { API_URL, TOKEN } from "../../../variables/constants";

const AddCarosserie = ({
  show,
  handleClose,
  editMode,
  selectedCarrosserie,
  onAddSuccess,
  onUpdateSuccess,
  existingCarosseries, // Prop for duplicate check
}) => {
  const [loading, setLoading] = useState(false);
  const [nom, setNom] = useState("");
  const [selectedCategorie, setSelectedCategorie] = useState("");
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    // Reset form fields when modal is shown for adding new or for editing
    if (editMode && selectedCarrosserie) {
      setNom(selectedCarrosserie.libelleParametre || "");
      setSelectedCategorie(selectedCarrosserie.categorie?.categorieId || "");
    } else {
      setNom("");
      setSelectedCategorie("");
    }

    // Fetch categories regardless of edit mode
    axios
      .get(`${API_URL}/api/categorie`, {
        headers: { Authorization: `Bearer ${TOKEN}` },
      })
      .then((res) => setCategories(res.data))
      .catch((err) => {
        console.error(err);
        toast.error("Erreur lors de la récupération des catégories");
      });
  }, [editMode, selectedCarrosserie, show]); // Added 'show' to dependency array

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const trimmedNom = nom.trim();
    const selectedCat = categories.find((cat) => cat.categorieId === parseInt(selectedCategorie));

    // --- Duplicate Check Logic ---
    if (!editMode) {
      // For adding, check against all existing carosseries
      const isDuplicate = existingCarosseries.some(
        (item) =>
          item.libelleParametre.trim().toLowerCase() === trimmedNom.toLowerCase() &&
          item.categorie?.categorieId === selectedCat?.categorieId
      );

      if (isDuplicate) {
        toast.warn("Une carrosserie avec ce nom et cette catégorie existe déjà.");
        setLoading(false);
        return;
      }
    } else {
      // For editing, check against existing carosseries EXCLUDING the one being edited
      const isDuplicate = existingCarosseries.some(
        (item) =>
          item.parametreId !== selectedCarrosserie.parametreId && // Exclude the current item
          item.libelleParametre.trim().toLowerCase() === trimmedNom.toLowerCase() &&
          item.categorie?.categorieId === selectedCat?.categorieId
      );

      if (isDuplicate) {
        toast.warn("Une autre carrosserie avec ce nom et cette catégorie existe déjà.");
        setLoading(false);
        return;
      }
    }
    // --- End Duplicate Check Logic ---

    const carrosserieData = {
      ...selectedCarrosserie, // Keep existing ID for PUT request
      libelleParametre: trimmedNom,
      typeParametre: "CAROSSERIE",
      categorie: selectedCat,
    };

    try {
      const response = editMode
        ? await axios.put(`${API_URL}/api/parametre`, carrosserieData, {
            headers: { Authorization: `Bearer ${TOKEN}`, "Content-Type": "application/json" },
          })
        : await axios.post(`${API_URL}/api/parametre`, carrosserieData, {
            headers: { Authorization: `Bearer ${TOKEN}`, "Content-Type": "application/json" },
          });

      toast.success(editMode ? "Carrosserie modifiée avec succès" : "Carrosserie ajoutée avec succès");

      if (!editMode) {
        onAddSuccess(response.data);
      } else {
        onUpdateSuccess(response.data);
      }
      handleClose(); // Close modal after success
    } catch (error) {
      console.error(error);
      if (error.response && error.response.status === 409) {
        toast.error("Erreur : Cette carrosserie existe déjà sur le serveur.");
      } else {
        toast.error("Erreur lors de l'enregistrement de la carrosserie.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={handleClose} size="lg" centered>
      <Modal.Body>
        <button type="button" className="btn-close btn-primary" onClick={handleClose} aria-label="Close" />
        <div className="text-center mb-4">
          <h4 className="address-title mb-2">{editMode ? "Modifier la" : "Ajouter une"} carrosserie</h4>
        </div>
        <form className="row g-3" onSubmit={onSubmit}>
          <div className="col-12">
            <label className="form-label">Nom</label>
            <input
              type="text"
              className="form-control"
              placeholder="Nom de la carrosserie"
              value={nom}
              onChange={(e) => setNom(e.target.value)}
              required
            />
          </div>
          <div className="col-12">
            <label className="form-label">Catégorie</label>
            <select
              className="form-select"
              value={selectedCategorie}
              onChange={(e) => setSelectedCategorie(e.target.value)}
              required
            >
              <option value="">Sélectionner la catégorie</option>
              {categories.map((cat) => (
                <option key={cat.categorieId} value={cat.categorieId}>
                  {cat.nom}
                </option>
              ))}
            </select>
          </div>
          <div className="col-12 text-center">
            <button type="submit" className="btn btn-primary me-3" disabled={loading}>
              {loading ? (
                <>
                  <span className="spinner-grow spinner-grow-sm me-1" role="status" aria-hidden="true" />
                  Enregistrement...
                </>
              ) : (
                "Enregistrer"
              )}
            </button>
            <button type="button" className="btn btn-label-secondary" onClick={handleClose}>
              Annuler
            </button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};

export default AddCarosserie;